import Vue from 'vue'
import moment from 'moment'

Vue.filter('time', function (value, begin, end) {
  var dayDate = moment(moment(value),"", "nl", true)
  return dayDate.format("HH:mm")
})

Vue.filter('YesNo', function (value, begin, end) {
  return (value == 1) ? 'Ja' : 'Nee'
})

Vue.filter('date_nl', function (value, begin, end) {
  return moment(value).format('DD-MM-YYYY')
})

Vue.filter('date_time_nl', function (value, begin, end) {
  return moment(value).format('DD-MM-YYYY HH:II')
})

Vue.filter('humanFileSize', function (value, begin, end) {
  return humanFileSize(value, true)
})

Vue.filter('timeAgoShort', (date) => {
  let now = moment()
  return moment.duration(now.diff(date)).locale('nl').humanize()
})

Vue.filter('timeAgoTwitter', (date) => {
  let now = moment()
  let diff = moment.duration(now.diff(date)).locale('nl')
  let seconds = diff._milliseconds / 1000;  
  if(seconds <= 60){
    return `${Math.ceil(seconds)} sec`
  }
  if(seconds <= (60*60)){
    return `${Math.floor(seconds/(60))} min`
  }
  if(seconds <= (60*60*24)){
    return `${Math.floor(seconds/(60*60))} uur`
  }
  if(seconds <= (60*60*24*7)){
    return `${Math.floor(seconds/(60*60*24))} dgn`
  }
  else {
    return `${Math.round(seconds/(60*60*24*365))} jaar`
  }
})

export const humanFileSize = (bytes, si) => {
  let thresh = si ? 1000 : 1024
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }
  var units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  var u = -1
  do {
    bytes /= thresh
    ++u
  }
  while (Math.abs(bytes) >= thresh && u < units.length - 1)
  return bytes.toFixed(1) + ' ' + units[u]
}